import _range from 'lodash/range';
import React from 'react';

import * as S from './styles';

interface Props {
    range: number;
    currentRate?: number;
    onRateChange: (rate: number) => void;
    minLabel?: string;
    maxLabel?: string;
    largeLabels?: boolean;
    fullWidth?: boolean;
}

export const CircularRates: React.SFC<Props> = ({
    range,
    currentRate,
    minLabel,
    maxLabel,
    onRateChange,
    largeLabels,
    fullWidth,
}) => (
    <S.CircularRatesWrapper fullWidth={fullWidth}>
        {minLabel && <S.CircularRatesLabel large={largeLabels}>{minLabel}</S.CircularRatesLabel>}
        <S.CircularRates fullWidth={fullWidth}>
            {_range(1, range + 1).map(rate => (
                <S.CircularRate
                    selected={rate === currentRate}
                    onClick={() => onRateChange(rate)}
                    key={rate}
                >
                    {rate}
                </S.CircularRate>
            ))}
        </S.CircularRates>
        {maxLabel && <S.CircularRatesLabel large={largeLabels}>{maxLabel}</S.CircularRatesLabel>}
    </S.CircularRatesWrapper>
);
